export default {"src":"/_next/static/media/houseAndPerson_24.3120b489.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};